// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"905dedc5","238":"8f235286","453":"9b1a05f2"}[chunkId] + ".chunk.js";
};